import { AfterContentInit, Component, ContentChildren, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild } from '@angular/core';
import { OptionComponent } from '../option/option.component';
import { SelectItem } from 'primeng/api';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';

@Component({
  selector: 'townip-multi-dropdown',
  templateUrl: './multi-dropdown.component.html',
  styleUrls: ['./multi-dropdown.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiDropdownComponent),
    multi: true,
  }]
})
export class MultiDropdownComponent implements OnInit, OnChanges, AfterContentInit, ControlValueAccessor {

  @ViewChild(MultiSelect)
  public multiSelect: MultiSelect;

  @ContentChildren(OptionComponent)
  private availableOptions: QueryList<OptionComponent>;

  @Input()
  public filter = true;

  /**
   * Set to true if you want the dropdown to follow the width if its container
   */
  @Input()
  public fluid = false;

  @Input()
  public placeholder = 'Select';

  @Input()
  public filterPlaceHolder = '';

  @Input()
  public disabled = false;

  @Input()
  public size = ''; // sm lg or blank(Default)

  @Input()
  public appendTo: string;

  @Input()
  public dataKey: string;

  @Input()
  public selectionLimit: number;

  @Input()
  public maxSelectedLabels: number = 3;

  @Input()
  public forceMenuBottomPosition = false;

  @Input()
  public selectedItemsLabel: string = '{0} items';

  @Output()
  public selected = new EventEmitter<any>();

  public onChange: any;

  public onTouched: any;

  public selectItems: SelectItem[] = [];

  public currentValue: any;

  public baseStyle: string;

  constructor() {
  }

  public ngOnInit(): void {
    this.parseStyle();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.parseStyle();
  }

  public ngAfterContentInit(): void {
    this.parseOptions();
    this.availableOptions
      .changes
      .subscribe(() => {
        this.parseOptions();
      });
  }

  public writeValue(value: any): void {
    this.currentValue = value;
  }

  public registerOnChange(func: any): void {
    this.onChange = func;
  }

  public registerOnTouched(func: any): void {
    this.onTouched = func;
  }

  public handleTouched(): void {
    if (!this.onTouched) {
      return;
    }
    this.onTouched();
  }

  public handleSelection(): void {
    if (this.onChange) {
      this.onChange(this.currentValue);
    }

    if (this.onTouched) {
      this.onTouched(true);
    }

    this.selected.emit(this.currentValue);
  }

  private parseOptions(): void {
    this.selectItems = this.availableOptions.map(opt => {
      return { label: opt.label, value: opt.value };
    });
  }

  private parseStyle(): void {
    this.baseStyle = 'app-multiselect';

    if (this.forceMenuBottomPosition) {
      this.baseStyle += ' edit-column-popover';
    }

    if (this.fluid) {
      this.baseStyle += ' full-width';
    }

    if (this.size && this.size !== '') {
      this.baseStyle += ` ${this.size}`;
    }
  }
}
